module.exports = __webpack_public_path__ + "media/images/social/vk-dark-6b423b0515f38bb3b5022933f0ba80c1.svg";